import { useEffect } from "react";
import { Navigate } from "react-router";
import { logout } from "stores/actions/auth";

// a gene
const AdminLogoutView = () => {
  useEffect(() => {
    logout();
  }, []);

  return <Navigate to="/admin/login" />;
};

export default AdminLogoutView;
